import ProjectData from '@/data/ProjectData.ts'

export default [
  new ProjectData("phantom-squad", "Phantom Squad", "img/projects/phantom-squad-icon.gif", 
    `
    <div class="paragraph">
        Currently in development, <strong>Phantom Squad</strong> is Rainbow Six meets Hotline Miami. It's a cooperative tactical shooter where you collaborate to draw and discuss plans in real-time before you try to execute them flawlessly.
    </div>
    <div class="paragraph center">
    <iframe class="youtube" src="https://www.youtube.com/embed/94mmLdn1CYs" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
      <a href='https://store.steampowered.com/app/2841770/Phantom_Squad/' target="_blank">
        <img alt='Wishlist on Steam' src='img/wishlist-steam.png' style="width: 300px;"/>
      </a>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
        <li>Online co-op using Unity Relay, Vivox and Netcode for GameObjects</li>
        <li>Players use the top-down view, real-time freeform collaborative tools, voice chat to come up with the best short-term plan.</li>
        <li>Fast-paced action and satisfying gunplay</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/phantom-squad-ss1.jpg" alt="Phantom Squad Screenshot" />
        <img class="pc-screenshot" src="img/projects/phantom-squad-ss2.jpg" alt="Phantom Squad Screenshot" />
        <img class="pc-screenshot" src="img/projects/phantom-squad-ss3.jpg" alt="Phantom Squad Screenshot" />
        <img class="pc-screenshot" src="img/projects/phantom-squad-ss4.jpg" alt="Phantom Squad Screenshot" />
    </div>
    `, "#000000", true, true),
    new ProjectData("hyper-casual", "Hyper-Casual Games", "img/projects/hypercasual-icon.gif", 
    `

    <div class="paragraph">
    The following are attempts at games that I've tested in collaboration with a few hyper-casual publishers (Voodoo and Homa mainly), trying to reach a low enough "Cost per Install" through social network ads.<br/>
    Each game took 2 weeks to produce and are very short (only a few minutes of gameplay).<br/>
    <font style="font-size: 0.7em">Some games have been removed from the store, for these you can get the .apk here but you'll need to <a href="https://www.androidauthority.com/how-to-install-apks-31494/">authorize third party apk installation</a>.</font><br/><br/>
    </div>

    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/jz0cJWlkud0?autoplay=0" frameborder="0" allowfullscreen></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Blitz Army</div>
      Gather your troops and lead them to defeat the enemy!<br/>
Command soldiers, tanks, helicopters and many more to fight swarms of enemies.<br/>
Use your wits and reflexes to place your navigate your army and take the advantage over your opponents.<br/>
Collect money to improve your army and your hero.<br/>
<br/>
Download now and become the best army commander!
      </div>
      <div class="paragraph">
        <a href='https://play.google.com/store/apps/details?id=games.cheekymonkey.blitzarmy&utm_source=scheefer.me' target="_blank">
          <img class="hc-badge" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
        </a>
      </div>
      <div style="clear:both"></div>
    </div>

<hr/>

    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/I8eQ3jCjaP4?autoplay=0" frameborder="0" allowfullscreen></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Glory Gloves</div>
      Punch your way to World champion<br/>
      <br/>
      This revisiting of classic arcade to casual mobile game standards will knock your teeths out!<br/>
Punch in rhythm, read your enemies attacks and punish them with blocks and counter punches.<br/>
Parry all their jabs and FINISH THEM!

<div class="paragraph">
        <a href='https://cheekymonkeygames.blob.core.windows.net/apk/glory-gloves.apk'>
        Download apk
        </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr/>

    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/NxxecFc5wbE?autoplay=0" frameborder="0" allowfullscreen></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Banana Madness</div>
      Help the monkey get all the bananas!<br/>
      <br/>
      Swipe to throw the monkey and collect all the bananas. Find your way to the final treasure.<br/>
      Compete with other players to go as fast as possible, or to complete the levels using the least number of swipes!

      <div class="paragraph">
      <a href='https://cheekymonkeygames.blob.core.windows.net/apk/banana-madness.apk'>
      Download apk
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr/>
    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/kF8lPuyULbs?autoplay=0" frameborder="0" allowfullscreen></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">OMG A Killer!</div>
      Run away from the killer! Throw things in their face!<br/>
      <br/>
      A banana 🍌 or a brick 🧱? A toilet paper roll 🧻 or a soccer ball ⚽? <br/>
You decide the best things to throw at a killer chasing you! But be careful, too many mistakes and they'll catch you...<br/>
AND remember to collect enough objects to knock them out at the end of the run!

<div class="paragraph">
      <a href='https://cheekymonkeygames.blob.core.windows.net/apk/omg-a-killer.apk'>
      Download apk
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr/>
    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/MP2R0wvB9Ew?autoplay=0" frameborder="0" allowfullscreen></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Park Keeper</div>
      It's your shift! Take care of the park.<br/>
      <br/>
      Water the plants and care for them. Protect them, help them blossom.<br/>
Unlock new equipment to make your job easier and faster.<br/>
<br/>
Make it the most beautiful park in the world that everyone will enjoy!
<div class="paragraph">
      <a href='https://cheekymonkeygames.blob.core.windows.net/apk/park-keeper.apk'>
      Download apk
      </a>
      </div>
      </div>
      
      <div style="clear:both"></div>
    </div>

    <hr/>


    <div class="paragraph">
      <div class="hc-left">
        <div>
          <iframe class="youtube-hc" src="https://www.youtube.com/embed/GStrNB13jsI?autoplay=0" frameborder="0" allowfullscreen></iframe>
        </div>
        
      </div>
      <div class="hc-right">
      <div class="hc-title">Inferno Tower!</div>
      Save as many people as possible and escape the burning tower<br/>
      <br/>
      Use your grapple to climb on top of the tower. Avoid fire and explosions, grab people and carry them to the helicopter!

      <div class="paragraph">
      <a href='https://cheekymonkeygames.blob.core.windows.net/apk/inferno-tower.apk'>
      Download apk
      </a>
      </div>

      </div>
      
      <div style="clear:both"></div>
    </div>

    `, "#ed3a17", true, false),
    
    new ProjectData("jumpy-deer", "Jumpy Deer", "img/projects/jumpy-deer-icon.png", 
    `
    <div class="paragraph">
        Released in <strong>2015</strong> on Google Play store (and Apple App Store and Microsoft Store at the time), <strong>Jumpy Deer</strong> is a simple but addictive mobile game where you just tap right or left to climb a procedurally generated mountain, trying to avoid a few threats along the way.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/FP5ZndsHZ_E" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">

      <a href='https://play.google.com/store/apps/details?id=com.nexthead.jumpydeer&utm_source=scheefer.me' target="_blank">
          <img class="hc-badge" alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' />
        </a>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
        <li>Procedurally, infinitely generated environment</li>
        <li>High score system, with optional connection to Facebook APIs to compare scores and invite friends to play</li>
        <li>Unity Ads</li>
        <li>Low-poly art style done in Blender</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="phone-screenshot" src="img/projects/jumpy-deer-ss1.png" alt="Jumpy Deer Screenshot" />
        <img class="phone-screenshot" src="img/projects/jumpy-deer-ss2.png" alt="Jumpy Deer Screenshot" />
    </div>
    `, "#23bd69"),
    new ProjectData("neon-escape", "Neon Escape", "img/projects/neon-escape-icon.gif", 
    `
    <div class="paragraph">
        Released in <strong>2022</strong> on the Play Store, <strong>Neon Escape</strong> has you making epic parkour moves while shooting robots in the face.
    </div>
    <div class="paragraph center">
    <iframe class="youtube" src="https://www.youtube.com/embed/yKeJKTGR2nc" frameborder="0" allowfullscreen></iframe>
    </div>
    <div class="paragraph center">
      <a href='https://play.google.com/store/apps/details?id=games.cheekymonkey.neonescape&utm_source=scheefer.me' target="_blank">
        <img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style="width: 300px;"/>
      </a>
    </div>

    <div class="paragraph">
        Main features :
        <ul>
        <li>Infinite, procedurally generated</li>
        <li>Addictive "one last try" type of game</li>
        <li>Original, pumping synthwave soundtrack beating with visual sync</li>
        <li>Monetization through Rewarded Ads, using UnityAds</li>
        <li>Collectibles, weapons and bonuses, leaderboards and achievements using Google Play Games</li>
        </ul>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/neon-escape-ss1.jpg" alt="Neon Escape Screenshot" />
        <img class="pc-screenshot" src="img/projects/neon-escape-ss2.jpg" alt="Neon Escape Screenshot" />
        <img class="pc-screenshot" src="img/projects/neon-escape-ss3.gif" alt="Neon Escape Screenshot" />
        <img class="pc-screenshot" src="img/projects/neon-escape-ss4.jpg" alt="Neon Escape Screenshot" />
    </div>
    `, "#530ba3", false, true),
    new ProjectData("the-gatherer", "The Gatherer", "img/projects/the-gatherer-icon.gif", `
    <div class="paragraph">
        <strong>The Gatherer</strong> is an FPS game with a grappling hook. The objective is to collect items while evading or killing enemies with your blaster.<br/>
        This small game is part of a <strong>challenge I've set myself up with in 2020</strong>, consisting of creating 3 “polished prototypes” in 3 months, that I can use as a portfolio to showcase my technical skills using Unity to studios and recruiters. <a target="_blank" href="https://thegamedevquest.tumblr.com/post/623424052550303744/so-whats-the-plan">More info on that challenge</a>.
    </div>
    <div class="paragraph center">
    <iframe class="youtube" src="https://www.youtube.com/embed/Hul17MrLv8I" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
    Main features:
    <ul>
    <li>Satisfying grappling hook using pull and push forces</li>
    <li>LODs, triplanar shaders, messaging system, object pooling</li>
    <li>Art mostly done by me using Blender and Substance Painter</li>
    </ul>
    </div>

    <div class="paragraph">
    I've covered interesting technical aspects here:
    <ul>
      <li><a href="https://thegamedevquest.tumblr.com/post/629709215382077440/prototype-2-finding-the-fun" target="_blank">Finding the fun</a></li>
      <li><a href="https://thegamedevquest.tumblr.com/post/629755494089752577/using-triplanar-shader-to-speed-up-level-design" target="_blank">Using triplanar shader to speed up level design</a></li>
      <li><a href="https://thegamedevquest.tumblr.com/post/629765195864080384/how-i-handled-fps-arms-and-weapons-animations" target="_blank">How I handled FPS arms and weapons animations</a></li>
      <li><a href="https://thegamedevquest.tumblr.com/post/629766609065656320/prototype-2-a-post-mortem" target="_blank">A post mortem</a></li>
    </ul>
    </div>

    <div class="paragraph">
    <div class="notice">
    Windows build available on <a href="https://schouffy.itch.io/the-gatherer" target="_blank">itch.io</a>.
    Source code is available on <a href="https://github.com/schouffy/unity-grapple-shooter/" target="_blank">GitHub</a>.
    </div>
    </div>

    <div class="paragraph center">
    <img class="pc-screenshot" src="img/projects/the-gatherer-ss2.gif" alt="The Gatherer Screenshot" />
    <img class="pc-screenshot" src="img/projects/the-gatherer-ss1.png" alt="The Gatherer Screenshot" />
    <img class="pc-screenshot" src="img/projects/the-gatherer-ss3.png" alt="The Gatherer Screenshot" />
    <img class="pc-screenshot" src="img/projects/the-gatherer-ss4.gif" alt="The Gatherer Screenshot" />
    </div>
    `, "#5a78af"),
    new ProjectData("skyline-rider", "Skyline Rider", "img/projects/skyline-rider-icon.gif", `
    <div class="paragraph">
        <strong>Skyline Rider</strong> is a 2D cinematic platformer with some parkour moves. The objective is to proceed through the levels without dying to enemies or the environment.<br/>
            This small game is part of a <strong>challenge I've set myself up with in 2020</strong>, consisting of creating 3 “polished prototypes” in 3 months, that I can use as a portfolio to showcase my technical skills using Unity to studios and recruiters. <a target="_blank" href="https://thegamedevquest.tumblr.com/post/623424052550303744/so-whats-the-plan">More info on that challenge</a>.
    </div>
    <div class="paragraph center">
        <iframe class="youtube" src="https://www.youtube.com/embed/pawzs-Kftbs" frameborder="0" allowfullscreen></iframe>
    </div>

    <div class="paragraph">
        Main features:
        <ul>
        <li>Smooth animations using Mecanim and 3D models flattened as pixel art</li>
        <li>Scripted sequences for introduction and outro</li>
        <li>Parkour moves: Run, jump, slide, climb, wall jump</li>
        <li>Stealth AI and mechanics</li>
        <li>Art mostly done by me using Blender and Aseprite (strongly inspired by Canabalt and Unworthy)</li>
        </ul>
    </div>

    <div class="paragraph">
        I've covered interesting technical aspects here:
        <ul>
        <li><a href="https://thegamedevquest.tumblr.com/post/624240391247577088/how-to-make-a-game-on-your-own-when-youre-just-a" target="_blank">How to make a game on your own when you're "just" a programmer ?</a></li>
        <li><a href="https://thegamedevquest.tumblr.com/post/629605895637286912/from-blender-to-pixel-art" target="_blank">From Blender to pixel art</a></li>
        <li><a href="https://thegamedevquest.tumblr.com/post/629672447108661248/ragdolling-a-2d-platformer" target="_blank">Ragdolling a 2D platformer</a></li>
        <li><a href="https://thegamedevquest.tumblr.com/post/629680023595515904/scripted-sequence-hell" target="_blank">Scripted sequence hell</a></li>
        <li><a href="https://thegamedevquest.tumblr.com/post/629687574287548416/prototype-1-a-post-mortem" target="_blank">A post mortem</a></li>
        </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
        Playable in the browser (WebGL) on <a href="https://schouffy.itch.io/skyline-rider" target="_blank">itch.io</a>.
        Source code is available on <a href="https://github.com/schouffy/unity-skyline-rider" target="_blank">GitHub</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/skyline-rider-ss1.gif" alt="Skyline Rider Screenshot" />
        <img class="pc-screenshot" src="img/projects/skyline-rider-ss2.png" alt="Skyline Rider Screenshot" />
        <img class="pc-screenshot" src="img/projects/skyline-rider-ss4.png" alt="Skyline Rider Screenshot" />
        <img class="pc-screenshot" src="img/projects/skyline-rider-ss3.gif" alt="Skyline Rider Screenshot" />
    </div>
    `, "#383838"),
    new ProjectData("altered-mask", "Altered Mask", "img/projects/altered-mask-icon.png", `
    <div class="paragraph">
        <strong>Altered Mask</strong> is a 3 players local competitive game. Each player must score more points than the two opponents, and has a powerup with a cooldown.<br/>
            This game was made in two days during the <strong>Hits Playjam 2015</strong> (far-fetched theme was: "Bambification"). I was the main developer along with two artists and a music composer.
    </div>
    
    <div class="paragraph">
        Main features of this project:
        <ul>
          <li>Balanced multiplayer map and powerups</li>
          <li>3 players controls either on keyboard and/or gamepad</li>
          <li>Teamwork with artists and composer</li>
        </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
        Windows build available on <a href="https://schouffy.itch.io/altered-mask" target="_blank">itch.io</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/altered-mask-ss1.png" alt="Altered Mask Screenshot" />
        <img class="pc-screenshot" src="img/projects/altered-mask-ss2.jpg" alt="Altered Mask Screenshot" />
    </div>
    `, "#e80fb7"),
    new ProjectData("zeroculus", "ZEROculus", "img/projects/zeroculus-icon.png", `
    <div class="paragraph">
        <strong>ZEROculus</strong> is a single player VR "rollercoaster-type" game for the Oculus Rift DK2. You just move your head to avoid obstacles while pulled by a spaceship.<br/>
            This game was made in two days during the <strong>Virtual Jam 2015</strong>. I was the main developer along with two artists, a game designer and a music composer.
    </div>
    
    <div class="paragraph">
        Main features of this project:
        <ul>
          <li>Display and controls focused for Virtual Reality with Rift DK2</li>
          <li>Physics-controlled movements</li>
          <li>Teamwork with game designer, artists and composer</li>
        </ul>
    </div>

    <div class="paragraph">
        <div class="notice">
        Windows build available on <a href="https://schouffy.itch.io/zeroculus" target="_blank">itch.io</a>.
        Source code available on <a href="https://github.com/schouffy/virtualjam" target="_blank">GitHub</a>.
        </div>
    </div>

    <div class="paragraph center">
        <img class="pc-screenshot" src="img/projects/zeroculus-ss1.jpg" alt="ZEROculus Screenshot" />
        <img class="pc-screenshot" src="img/projects/zeroculus-ss2.jpg" alt="ZEROculus Screenshot" />
        <img class="pc-screenshot" src="img/projects/zeroculus-ss3.jpg" alt="ZEROculus Screenshot" />
    </div>`, "#e48246")
];